import { Auth as AWSAuth } from '@aws-amplify/auth'
import { Hub as AWSHub } from '@aws-amplify/core'

export const Auth = AWSAuth
export const Hub = AWSHub
